import(/* webpackMode: "eager", webpackExports: ["CollectionDetail"] */ "/app/askfinz.com/components/marketing/collection-detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
